import { render, staticRenderFns } from "./ExpiredPolicies.vue?vue&type=template&id=3bbc953d&scoped=true&"
import script from "./ExpiredPolicies.ts?vue&type=script&lang=ts&"
export * from "./ExpiredPolicies.ts?vue&type=script&lang=ts&"
import style0 from "./ExpiredPolicies.vue?vue&type=style&index=0&id=3bbc953d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbc953d",
  null
  
)

export default component.exports